module.exports = __webpack_public_path__ + "media/images/posts/wait_for_shopping-e254fb033221244bafba83d7bdfdc894.jpg";